export const SET_PARTICIPANT = 'PARTICIPANT/SET_PARTICIPANT'
export const SET_PARTICIPANTS = 'PARTICIPANT/SET_PARTICIPANTS'
